import React from 'react';
import PropTypes, { string, bool } from 'prop-types';

const FormGroup = ({
    children,
    flatBottom,
    htmlFor,
    inlineLabel,
    label,
    labelIsBold,
    labelIsHidden
}) => {
    const formGroupClassName = `form-group ${
        flatBottom ? 'form-group--no-margin-bottom' : ''
    } ${inlineLabel ? 'form-group--flex' : ''}`;
    const labelClassName = `form-label ${labelIsHidden ? 'u-sr-only' : ''}`;
    const boldLabelClassName = 'form-label--bold';

    return (
        <div className={formGroupClassName} id={`form-group-${htmlFor}`}>
            <label
                className={`${labelClassName} ${
                    labelIsBold ? boldLabelClassName : ''
                }`}
                htmlFor={htmlFor}
            >
                {label}
            </label>
            {children}
        </div>
    );
};

FormGroup.propTypes = {
    children: PropTypes.node.isRequired,
    flatBottom: bool,
    htmlFor: string.isRequired,
    inlineLabel: bool,
    label: string.isRequired,
    labelIsBold: bool,
    labelIsHidden: bool
};

export default FormGroup;
